var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VAdministrationSecondaryTable',{attrs:{"head":['ID', 'project', 'address', 'city'],"is-table-loading":_vm.isTableLoading,"rows":_vm.transformedProjects,"hide-actions":"","empty-row-button-label":"","relocate-route-name":"administration.projects.edit"}})
}
var staticRenderFns = []

export { render, staticRenderFns }